import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { LoaderService } from './loader.service';
import { tap } from '../../../node_modules/rxjs/operators';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as fromUser from '../state/user.reducer';
import * as userAction from '../state/user.action';
@Injectable({
    providedIn: 'root'
})
// Every get and post request is passed from here and append authorization header for log in User token.
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService, private loaderService: LoaderService, private router: Router, private store: Store<fromUser.UserState>,) { }

    // All http request will pass here in interceptor before service call
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let hideloader = request.headers.get('HideLoader');
        // Show loader on request
        if (!hideloader) {
            this.showLoader();
        }

        // add authorization header with jwt token if available
        let currentUser = this.authService.getLoggedInUser();
        const url = this.router['location']._platformLocation.location.href;
        if (!url.includes("register") && !url.includes("forgot-password"))
            if (currentUser && currentUser.Token && this.isTokenExpired(currentUser.Token)) {
                request = request.clone({
                    setHeaders: {
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Bearer ${currentUser.Token}`
                    }
                });
            }
            else {
                request = request.clone({
                    setHeaders: {
                        'Access-Control-Allow-Origin': '*'
                    }
                });
                this.authService.logOut();
                this.router.navigate(['/login']);
                this.store.dispatch(new userAction.LogOutUser());
                localStorage.clear()
            }

        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            // Hide loader on response
            if (event instanceof HttpResponse) {
                this.onEnd();
            }
        },
            (err: any) => {
                this.onEnd();
            }));
    }

    isTokenExpired(token: any): any {
        if (!token) {
            return false;
        }
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            return false;
        }
        try {
            const payload = JSON.parse(atob(tokenParts[1]));
            const currentTime = Math.floor(Date.now() / 1000);
            const expTime = payload.exp;
            if (expTime && currentTime < expTime) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    }
    // hide loader on get response
    private onEnd(): void {
        this.hideLoader();
    }

    // show loader function
    private showLoader(): void {
        this.loaderService.show();
    }

    // hide loader function
    private hideLoader(): void {
        this.loaderService.hide();
    }
}
